import { useState, forwardRef } from "react";
import './RacesSection.css';

const raceData = {
  Derp: {
    img: "/races/derp.png",
    shirt: "/shirts/derp.png",
    background: "/locs/derpopolis.png",
    blurb: "Derps are derps, hailing from the Derp Region. They receive +1 to each stat.",
    locations: [
      {
        name: "Derpopolis",
        blurb:
          "Derpopolis is the largest city in the world. It sits at the intersection of the Dewd and Uppies Rivers, where they empty into the Specific Ocean. Citizens of Derpopolis specialize in Cloth production, making it a particularly popular choice for Mages and Priests.",
      },
      {
        name: "Derpe Plains",
        blurb:
          "The Derpe Plains sprawl along the southern leg of the Uppies River. Citizens specialize in Cotton Farming and Animal Hunting.",
      },
    ],
  },
  Elf: {
    img: "/races/elf.png",
    shirt: "/shirts/elf.png",
    background: "/locs/forest.png",
    blurb: "Elves are graceful and wise, getting +2 DEX and +2 WIS. They live in the Moona Region.",
    locations: [
      {
        name: "Uppies Mountains",
        blurb: "A vast mountain range with ample opportunities for Animal Hunting.",
      },
      {
        name: "Forest of Derp",
        blurb:
          "A serene glade of ancient trees, fed by the Uppies River. Citizens specialize in Woodcutting and Animal Hunting.",
      },
    ],
  },
  Dwarf: {
    img: "/races/dwarf.png",
    shirt: "/shirts/dwarf.png",
    background: "/locs/mines.png",
    blurb:
      "Dwarves are strong and resilient, masters of crafting and mining. They live in the Dewd Region. They get +2 STR and +2 CON.",
    locations: [
      {
        name: "Mines of Dewd",
        blurb:
          "A fortified mountain city of expert miners deep in the Dewd Mountains. Citizens specialize in mining Metal Ore.",
      },
      {
        name: "Hills of Dewd",
        blurb:
          "An open air dwarven county, centered around Hill City. Citizens specialize in Refining and Animal Hunting.",
      },
    ],
  },
};

// unreleased race card
const unreleasedRace = {
  name: "???",
  img: "/races/unk.png",
};

const RacesSection = forwardRef((props, ref) => {
  const [selectedRace, setSelectedRace] = useState("Elf");
  const current = raceData[selectedRace];

  return (
    <section
      ref={ref}
      className="section races"
      style={{
        backgroundImage: `url(${current.background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <h2 className="races-title">Races</h2>

      {/* Selector row ABOVE content */}
      <div className="race-cards race-selector">
        {Object.keys(raceData).map((race) => (
          <div
            key={race}
            className={`race-card ${selectedRace === race ? "active" : ""}`}
            onClick={() => setSelectedRace(race)}
          >
            <div className="race-card-image-container">
              <img src={raceData[race].img} alt={race} className="race-card-base" />
              <img src={raceData[race].shirt} alt={`${race} Shirt`} className="race-card-shirt" />
            </div>
            {/* No more text labels */}
          </div>
        ))}
        {/* unreleased race card */}
        <div className="race-card unreleased">
          <div className="race-card-image-container">
            <img src={unreleasedRace.img} alt="Unreleased Race" className="race-card-base" />
          </div>
        </div>
      </div>

      <div className="race-main">
        <div className="race-image-container">
          <img src={current.img} alt={selectedRace} className="race-image" />
          <img src={current.shirt} alt={`${selectedRace} Shirt`} className="race-shirt" />
        </div>

        <div className="race-info">
          <h3>{selectedRace}</h3>
          <p>{current.blurb}</p>
          {current.locations.map((loc, idx) => (
            <div key={idx} className="race-location">
              <h4>{loc.name}</h4>
              <p>{loc.blurb}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default RacesSection;
